// browse
export const BROWSE = 'browse';
// buy now

export const BUY_NOW = 'buy_now';

// realization
export const IN_REALIZATION = 'in_realization';

// bets
export const LOST_AUCTIONS = 'lost_auctions';
export const MY_BETS = 'my_bets';
export const NEW_BETS = 'new_bets';

// archive
export const ACCEPTED = 'accepted';
export const SOLD = 'sold';

// ads
export const ADS = 'ads';

export const navigationMapping = {
  [BROWSE]: {
    table_url: '/dashboard/browse',
    details_url: '/dashboard/browse/details',
  },
  [BUY_NOW]: {
    table_url: '/dashboard/buy-now',
    details_url: '/dashboard/buy-now/details',
  },
  [IN_REALIZATION]: {
    table_url: '/dashboard/realization',
    details_url: '/dashboard/realization/details',
  },
  [MY_BETS]: {
    table_url: '/dashboard/bets/my',
    details_url: '/dashboard/bets/details',
  },
  [NEW_BETS]: {
    table_url: '/dashboard/bets/new',
    details_url: '/dashboard/bets/details',
  },
  [ACCEPTED]: {
    table_url: '/dashboard/archive/accepted',
    details_url: '/dashboard/archive/details',
  },
  [SOLD]: {
    table_url: '/dashboard/archive/sold',
    details_url: '/dashboard/archive/details',
  },
  [ADS]: {
    table_url: '/dashboard/ads',
    new_ad_url: '/dashboard/ads/new-ad',
  },
};
